import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Alert, MenuItem, Select, InputLabel, FormControl } from '@mui/material';

const mockData = {
  clients: [
    { name: "Kasse 1", id: "1234-232324-343434-3434" },
    { name: "Kasse 2", id: "5234-532324-543434-5434" }
  ],
  lastClosingDate: "2025-03-15",
  lastClosingNumber: "CL-00123",
  cashBalances: {
    "1234-232324-343434-3434": {
      initialBalance: 150,
      revenue: 1000,
      expectedCashTotal: 1150,
    },
    "5234-532324-543434-5434": {
      initialBalance: 150,
      revenue: 1000,
      expectedCashTotal: 1150,
    }
  }
};

function CashCountProtocol() {
  const [selectedClient, setSelectedClient] = useState(mockData.clients[0].id);
  const [actualCash, setActualCash] = useState(0);
  const [difference, setDifference] = useState(null);

  const handleClientChange = (event) => {
    setSelectedClient(event.target.value);
    setActualCash(0);
    setDifference(null);
  };

  const handleSubmit = () => {
    const expectedTotal = mockData.cashBalances[selectedClient].expectedCashTotal;
    const diff = actualCash - expectedTotal;
    setDifference(diff);

    const transactionData = {
      type: 'CashCountProtocol',
      timestamp: new Date().toISOString(),
      clientId: selectedClient,
      details: {
        expectedTotal,
        actualCash,
        difference: diff,
        lastClosingDate: mockData.lastClosingDate,
        lastClosingNumber: mockData.lastClosingNumber
      },
    };

    console.log('CashCountProtocol transaction opened:', transactionData);
    // TODO: Actual TSE API calls
    console.log('CashCountProtocol transaction closed:', transactionData);
  };

  return (
    <Box sx={{ p: 3, border: '2px solid #1976d2', borderRadius: '8px', maxWidth: 400 }}>
      <Typography variant="h6" gutterBottom>Cash Count Protocol</Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Client</InputLabel>
        <Select value={selectedClient} label="Client" onChange={handleClientChange}>
          {mockData.clients.map(client => (
            <MenuItem key={client.id} value={client.id}>{client.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography variant="body2">Expected Total: {mockData.cashBalances[selectedClient].expectedCashTotal.toFixed(2)} €</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>Last Closing: {mockData.lastClosingDate} ({mockData.lastClosingNumber})</Typography>

      <TextField
        label="Actual Cash (€)"
        type="number"
        fullWidth
        value={actualCash}
        onChange={(e) => setActualCash(parseFloat(e.target.value))}
        sx={{ mb: 2 }}
      />

      <Button variant="contained" color="primary" onClick={handleSubmit}>
        Complete Cash Count
      </Button>

      {difference !== null && (
        <Alert severity={difference === 0 ? 'success' : 'warning'} sx={{ mt: 2 }}>
          Difference: {difference.toFixed(2)} €
        </Alert>
      )}
    </Box>
  );
}

export default CashCountProtocol;